import React from "react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container-heritage py-16 md:py-20 max-w-3xl mx-auto">

        {/* Heading */}
        <h1 className="font-serif text-3xl md:text-4xl font-medium text-foreground mb-4 text-center">
          Terms & Conditions
        </h1>

        <p className="text-sm text-muted-foreground text-center mb-12">
          Last updated: {new Date().toLocaleDateString("en-IN")}
        </p>

        {/* Content */}
        <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Introduction
            </h2>
            <p>
              Welcome to Anand Fashion. By accessing or using our website, you
              agree to comply with and be bound by these Terms and Conditions.
              Please read them carefully before using our services.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Nature of Services
            </h2>
            <p>
              This website is intended to showcase our collections and provide
              information about our products and services. We do not offer
              online purchasing, payments, or user accounts through this
              website.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Enquiries & Communication
            </h2>
            <p>
              Any enquiries made through phone, WhatsApp, or other communication
              channels are voluntary. Anand Fashion does not guarantee product
              availability or pricing through online enquiries.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Product Information
            </h2>
            <p>
              Product images and descriptions on this website are for reference
              purposes only. Actual products may vary in design, color, or
              availability when visiting our store.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Intellectual Property
            </h2>
            <p>
              All content on this website, including images, text, logos, and
              design elements, is the property of Anand Fashion and may not be
              copied, reproduced, or used without prior written permission.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              External Links
            </h2>
            <p>
              This website may contain links to third-party platforms such as
              WhatsApp, Instagram, or Google Maps. Anand Fashion is not
              responsible for the content or policies of these external sites.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Limitation of Liability
            </h2>
            <p>
              Anand Fashion shall not be held liable for any direct or indirect
              damages arising from the use of this website or reliance on the
              information provided herein.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Changes to Terms
            </h2>
            <p>
              We reserve the right to update or modify these Terms and Conditions
              at any time. Any changes will be effective immediately upon being
              posted on this page.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Contact Information
            </h2>
            <p>
              For any questions regarding these Terms and Conditions, you may
              contact us at our store in Udaipur, Rajasthan, or reach out via
              phone or WhatsApp.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Terms;
